import React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { ReactComponent as CheckMark } from '../assets/icons/checkmark.svg';

const Container = styled.div`
  .checkmark {
    left: 2px;
    top: 2px;
    height: 28px;
    width: 28px;
    position: relative;
    g path {
      fill: black;
    }
  }

  .circleAndSpacerHolder {
    display: flex;

    .circle {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      margin: 10px;

      &.completed {
        background-color: ${themes.colors.yellow};
      }

      &.inProgress {
        border: 10px solid ${themes.colors.yellow};
      }

      &.todo {
        border: 10px solid ${themes.colors.yellowLight};
      }
    }

    .spacer {
      border-radius: 6px;
      width: 56px;
      height: 6px;
      position: relative;
      top: 24px;
      margin-left: 4px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
        width: 28px;
      }

      &.completed,
      &.inProgress {
        background-color: ${themes.colors.yellow};
      }

      &.todo {
        background-color: ${themes.colors.yellowLight};
      }
    }
  }

  .titleHolder {
    float: right;

    .title {
      max-width: 52px;
      height: 18px;
      ${themes.fonts.FoundersGrotesk};
      font-size: 14px;
      text-align: center;

      &.todo {
        font-weight: normal;
        color: ${themes.colors.nightLight};
      }

      &.completed,
      &.inProgress {
        font-weight: bold;
        color: ${themes.colors.night};
      }
    }
  }
`;

export enum Status {
  Completed = 'completed',
  InProgress = 'inProgress',
  Todo = 'todo'
}

type Props = {
  title: string;
  status: Status;
  showSpacer: boolean;
};

const BubbleStep = (props: Props) => {
  const { title, showSpacer, status } = props;
  return (
    <Container>
      <div className="circleAndSpacerHolder">
        {showSpacer && <div className={`spacer ${status}`} />}
        <div className={`circle ${status}`}>
          {status === Status.Completed && <CheckMark className="checkmark" />}
        </div>
      </div>
      <div className="titleHolder">
        <div className={`title ${status}`}>{title}</div>
      </div>
    </Container>
  );
};

export default BubbleStep;
